<template>
  <div class="col-sm-12 col-xl-12 box-col-12 col-12">
    <div class="row">
      <div class="col-12 d-flex">
        <!-- Custom Date Range 按鈕，顯示選擇的日期範圍或默認文字 -->
        <button class="btn btn-outline-primary mb-4 ms-4 btn-customer" :class="{ active: activeButton === 'custom' }" @click="toggleCustomDateRange">
          {{ customDateLabel }}<i class="fa fa-angle-down"></i>
        </button>
        <!-- 其他篩選按鈕 -->
        <button class="btn btn-outline-primary mb-4 ms-4  btn-this-month" :class="{ active: activeButton === 'thisMonth' }" @click="setActiveButton('thisMonth')">
          This month
        </button>
        <button class="btn btn-outline-primary btn-last-month mb-4 ms-4" :class="{ active: activeButton === 'lastMonth' }" @click="setActiveButton('lastMonth')">
          Last month
        </button>
        <button class="btn btn-outline-primary btn-this-week mb-4 ms-4" :class="{ active: activeButton === 'thisWeek' }" @click="setActiveButton('thisWeek')">
          This week
        </button>
        <button class="btn btn-outline-primary btn-last-week mb-4 ms-4" :class="{ active: activeButton === 'lastWeek' }" @click="setActiveButton('lastWeek')">
          Last week
        </button>
      </div>
    </div>
    <div v-show="showDatePicker" class="datepicker-container">
      <Datepicker1 inline autoApply v-model="dateRange" :format="format" :enable-time-picker="false" range data-language="en"></Datepicker1>
      <button @click="applyCustomDateRange" class="btn btn-primary mt-2">Apply</button>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import Datepicker1 from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { useReportStore } from '@/store/driver/report';

const activeButton = ref('thisMonth');
const dateRange = ref([]);
const showDatePicker = ref(false);
const reportStore = useReportStore();

// 計算 custom 日期範圍顯示文字
const customDateLabel = computed(() => {
  if (dateRange.value.length === 2) {
    const start = format(dateRange.value[0]);
    const end = format(dateRange.value[1]);
    return `${start} ~ ${end}`;
  }
  return 'Custom date range';
});

// 設置按鈕狀態
const setActiveButton = (button) => {
  activeButton.value = button;
  showDatePicker.value = false;
  // 點擊其他按鈕時重置日期範圍
  dateRange.value = [];
  updateDisplayDate(button);
};

const toggleCustomDateRange = () => {
  showDatePicker.value = !showDatePicker.value;
  activeButton.value = 'custom';
};

// 日期格式化函數
const format = (date) => {
  // 檢查 date 是否為 Date 物件，並確保它是有效的
  if (date instanceof Date && !isNaN(date)) {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString().slice(-2); // 顯示最後兩位數的年份

    return `${day}/${month}/${year}`;
  }
  
  // 如果不是 Date 物件或無效的日期，返回空字串或其他預設值
  return '';
};


// 應用自定義日期範圍
const applyCustomDateRange = () => {
  if (dateRange.value.length === 1) {
    reportStore.fetchReportInfo('custom', dateRange.value[0].toLocaleDateString(), dateRange.value[0].toLocaleDateString());
  } else {
    reportStore.fetchReportInfo('custom', dateRange.value[0].toLocaleDateString(), dateRange.value[1].toLocaleDateString());
  }
  showDatePicker.value = false;
};

// 根據按鈕狀態更新日期
const updateDisplayDate = (button) => {
  const today = new Date();
  let startDate, endDate, period;

  switch (button) {
    case 'thisMonth':
      startDate = new Date(today.getFullYear(), today.getMonth(), 1);
      endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      period = 'this_month';
      break;
    case 'lastMonth':
      startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      endDate = new Date(today.getFullYear(), today.getMonth(), 0);
      period = 'last_month';
      break;
    case 'thisWeek':
      startDate = new Date(today.setDate(today.getDate() - today.getDay()));
      endDate = new Date(today.setDate(today.getDate() - today.getDay() + 6));
      period = 'this_week';
      break;
    case 'lastWeek':
      startDate = new Date(today.setDate(today.getDate() - today.getDay() - 7));
      endDate = new Date(today.setDate(today.getDate() - today.getDay() - 1));
      period = 'last_week';
      break;
    case 'custom':
      period = 'custom';
      break;
    default:
      return;
  }

  reportStore.fetchReportInfo(period, startDate.toLocaleDateString(), endDate.toLocaleDateString());
};

// 初始化預設為這個月
updateDisplayDate('thisMonth');
</script>

<style scoped>

.btn-customer{
  box-sizing: border-box;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px 24px;
  gap: 6px;

  width: 217px;
  height: 38px;

  border: 1px solid #5248DA;
  color: #5248DA;
  border-radius: 30px;
}

.btn-this-month{
  color: #5248DA;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px 24px;
  gap: 6px;

  width: 131px;
  height: 38px;
  border: 1px solid #5248DA;
  border-radius: 30px;
}

.btn-last-month{
  color: #5248DA;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px 24px;
  gap: 6px;

  width: 134px;
  height: 40px;
  border: 1px solid #5248DA;
  border-radius: 30px;
}

.btn-this-week{
  color: #5248DA;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px 24px;
  gap: 6px;

  width: 121px;
  height: 38px;

  /* Indigo */
  border: 1px solid #5248DA;
  border-radius: 30px;
}

.btn-last-week{
  color: #5248DA;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px 24px;
  gap: 6px;

  width: 124px;
  height: 38px;
  border: 1px solid #5248DA;
  border-radius: 30px;

}

.active {
  background-color: #00C962;
  color: white;
}

.datepicker-container {
  position: absolute;
  top: 50px;
  left: 10%;
  transform: translateX(-50%);
  z-index: 1000;
  background: white;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  padding: 10px;
  border-radius: 5px;
}
</style>
